/** @format */

import {useDuplicateOrder} from './use_duplicate_order';
import {IfElse} from 'frontier-utilities';
import {Button} from '@sttark/design-system';
import React from 'react';

export function DuplicateOrderButton({id, children}) {
    const {isPending, success, handleDuplicate} = useDuplicateOrder(id);

    // add handDuplicate function to the button onClick event
    const childrenWithProps = React.Children.map(children, child =>
        React.cloneElement(child, {handleDuplicate, isPending, success})
    );

    if (!children) {
        return (
            <div>
                <IfElse condition={!isPending}>
                    <Button label={'Create New Order'} onClick={handleDuplicate} primary small />
                    <Button primary small onClick={() => {}} disabled>
                        {!success ? 'Creating new order...' : 'Redirecting...'}
                    </Button>
                </IfElse>
            </div>
        );
    }

    return <>{childrenWithProps}</>;
}
